import React from "react";
import { ChevronDown } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
export default function OurSharedFuture() {
  return <section data-section-id="224433" id="halal-bold-delicious" className="bg-background text-foreground relative w-full min-h-screen flex items-center overflow-hidden" dir="ltr">
      {}
      <div className="absolute inset-0 bg-cover bg-center !bg-[url(https://logical-turkey.10web.cloud/wp-content/uploads/2026/04/Whathappened.jpg)]" />

      {}
      <div className="absolute inset-0 bg-[radial-gradient(circle_at_50%_50%,rgba(0,0,0,0.4)_0%,rgba(0,0,0,0.8)_100%)] pointer-events-none" />

      {}
      <div className="relative z-10 container mx-auto px-6 md:px-12 flex flex-col justify-center h-full items-center text-center">
        <div className="max-w-5xl">
          <h1 className="text-6xl md:text-8xl lg:text-[120px] font-bold font-serif text-white mb-6 leading-[1] tracking-wider">the best burgerS<br />in dfw</h1>
          <p className="text-xl md:text-2xl font-semibold font-default text-primary mb-10 max-w-2xl mx-auto leading-relaxed uppercase tracking-wide">
            Punjabi-American fusion. Certified halal. Irving, TX.
          </p>
          
          <div className="flex flex-wrap gap-4 justify-center">
            <Button asChild variant="secondary" size="lg" className="relative overflow-hidden group text-xl px-12 py-8 rounded-full border-none shadow-3xl bg-primary text-primary-foreground hover:scale-105 transition-transform duration-300 w-[280px]">
              <Link to="#">
                <span className="relative z-10 font-bold font-default">ORDER NOW</span>
                {}
                <div className="absolute inset-0 bg-primary/20 animate-pulse rounded-full blur-xl -z-10" />
                <div className="absolute inset-0 -translate-x-[150%] bg-gradient-to-r from-transparent via-white/40 to-transparent group-hover:translate-x-[150%] transition-transform duration-1000 ease-in-out" />
              </Link>
            </Button>
            
            <Button asChild variant="outline" size="lg" className="text-xl px-12 py-8 rounded-full bg-transparent border-secondary text-white hover:bg-secondary/20 hover:text-white backdrop-blur-md transition-all duration-300">
              <Link to="#">
                CATERING
              </Link>
            </Button>
          </div>
        </div>
      </div>

      {}
      
    </section>;
}